import React from "react";
import PropTypes from "prop-types";

const CheckboxIcon = ({ size = 16, color = "#242424" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 0C14.8807 0 16 1.11929 16 2.5V13.5C16 14.8807 14.8807 16 13.5 16H2.5C1.11929 16 0 14.8807 0 13.5V2.5C0 1.11929 1.11929 0 2.5 0H13.5ZM12.1611 5.08887C11.917 4.84499 11.5204 4.84486 11.2764 5.08887L6.78125 9.58398L4.72363 7.52637C4.47954 7.28249 4.08288 7.28236 3.83887 7.52637C3.5951 7.7704 3.59507 8.16712 3.83887 8.41113L6.33887 10.9111C6.45597 11.0282 6.61565 11.0936 6.78125 11.0938C6.94689 11.0938 7.10645 11.0282 7.22363 10.9111L12.1611 5.97363C12.4052 5.72956 12.4052 5.33294 12.1611 5.08887Z"
      fill={color}
    />
  </svg>
);

CheckboxIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default CheckboxIcon;
